<template>
  <div class="after-sale-address-container">
    <div class="label">售后地址</div>
    <div class="value">
      <span>{{ data.afterSalePerson }} </span>
      <span>{{ data.supplierPhone }} </span>
      <span>{{ address }}</span>
    </div>
    <div class="remark" v-if="data.remark">
      备注：{{ data.remark }}
    </div>
  </div>
</template>

<script>
import { areaList } from "@vant/area-data";
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      address: null
    }
  },
  created() {
    this.getAddress()
  },
  methods: {
    getAddress() {
      let address = ''
      const supplierAddress = this.data.supplierAddress
      if (supplierAddress) {
        const county = areaList.county_list[supplierAddress]
        const city =
          areaList.city_list[
            supplierAddress.toString().substr(0, 4) + "00"
          ];
        const province =
          areaList.province_list[
            supplierAddress.toString().substr(0, 2) + "0000"
          ];
        address = `${province} ${city} ${county} `;
      }
      this.address = address + this.data.supplierAddressDetail
    }
  }
}
</script>

<style lang="less" scoped>
.after-sale-address-container {
  margin: 28px 0;
  font-size: 28px;
  background-color: #fff;
  box-shadow: 0px 8px 16px 0px rgba(152, 152, 152, 0.06);
  border-radius: 12px;
  padding: 32px 28px;
  .label {
    padding-bottom: 28px;
  }
  .remark {
    padding-top: 20px;
  }
}
</style>